module.exports = __webpack_public_path__ + "static/media/gym-image.ff0d5b33.jpg";